import React, { useState } from 'react';
import { ShoppingCart, Menu } from "lucide-react";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
     <header className="fixed top-0 left-0 w-full bg-white text-gray-700 z-50 shadow-xl  opacity-100">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        {/* Left: Mobile Menu Button */}
        <div className="flex items-center space-x-2 md:hidden">
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <Menu className="w-6 h-6 text-gray-800" />
          </button>
        </div>

        {/* Desktop Nav + Actions */}
        <div className="hidden md:flex items-center justify-between w-full">
          {/* Navigation aligned to right */}
          <nav className="ml-auto flex items-center space-x-6">
            <a href="/" className="text-gray-700 hover:text-gray-900 font-medium">Home</a>
            <a href="/marketpage" className="text-gray-700 hover:text-gray-900 font-medium">Market</a>
            <a href="/blogpage" className="text-gray-700 hover:text-gray-900 font-medium">Blog</a>

            <div className="flex items-center space-x-4 ml-6">
              <button className="relative">
                <ShoppingCart className="w-5 h-5" />
                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  0
                </span>
              </button>
              <a href="/login" className="border px-3 py-1 rounded hover:bg-gray-100">Login</a>
              <a href="/signup"className="bg-orange-500 text-white px-4 py-1 rounded hover:bg-blue-500">Sign Up</a>
            </div>
          </nav>
        </div>

        {/* Right (Mobile) */}
        <div className="md:hidden flex items-center space-x-4">
          <button className="relative">
            <ShoppingCart className="w-5 h-5" />
            <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
              0
            </span>
          </button>
          <a href="/login" className="border px-3 py-1 rounded hover:bg-gray-100">Login</a>
          <a href="/signup" className="bg-orange-500 text-white px-4 py-1 rounded">Sign Up</a>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="md:hidden px-4 pb-4 space-y-4">
          <nav className="space-y-2">
            <a href="/" className="block text-gray-700 hover:text-gray-900">Home</a>
            <a href="/marketpage" className="block text-gray-700 hover:text-gray-900">Market</a>
            <a href="/blogpage" className="block text-gray-700 hover:text-gray-900">Blog</a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
